<template>
  <div>
    <!-- page meta -->
    <Head>
      <title>Get Started with the Platforma API</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="Sell exclusive content your subscribers can't get anywhere else."
      />
    </Head>
  </div>
  <!-- content start -->
  <body class="content-center overflow-x-hidden bg-[#fafbfc] font-['poppins']">
    <div
      class="api-header flex h-[120px] w-full justify-between px-[25px] pt-[35px]"
    >
      <!-- logo -->
      <Link href="/">
        <img
          :src="$filters.media_path('/images/platforma-logo-white-out.svg')"
          alt=""
          class="w-[300px]"
        />
      </Link>

      <div class="navigation">
        <input
          type="text"
          autocomplete="off"
          placeholder="Search the docs"
          class="hidden h-[50px] w-[400px] rounded-[30px] bg-white pl-[15px] text-[16px] font-normal focus:border-[#636363] focus:outline-none focus:ring-1 focus:ring-[#636363] sm:text-sm lg:block"
        />
      </div>

      <div>
        <button
          id="hamburger-button"
          class="relative h-8 w-8 cursor-pointer text-3xl lg:hidden"
        >
          <!-- &#9776; -->
          <div
            class="before:content[''] after:content[''] absolute top-4 -mt-0.5 h-1 w-8 rounded bg-white transition-all duration-500 before:absolute before:h-1 before:w-8 before:-translate-x-4 before:-translate-y-3 before:rounded before:bg-white before:transition-all before:duration-500 after:absolute after:h-1 after:w-8 after:-translate-x-4 after:translate-y-3 after:rounded after:bg-white after:transition-all after:duration-500"
          ></div>
        </button>
        <nav class="hidden space-x-8 text-xl lg:block" aria-label="main">
          <a
            href="https://help.platformarea.com"
            class="text-white hover:opacity-90"
            >Help Center</a
          >
        </nav>
      </div>
    </div>
    <section
      id="mobile-menu"
      class="api-header absolute top-[120px] mx-auto hidden h-[1100px] w-full origin-top animate-open-menu content-center lg:hidden"
    >
      <nav
        class="mx-auto flex w-full flex-col items-center py-8 px-[25px]"
        aria-label="mobile"
      >
        <a
          href="#https://help.platformarea.com"
          class="ml-[15px] w-full py-6 text-left text-lg text-white hover:opacity-60"
          >Help Center</a
        >
        <div class="navigation w-full">
          <input
            type="text"
            autocomplete="off"
            placeholder="Search the docs"
            class="block h-[50px] w-full rounded-[30px] bg-white pl-[25px] text-[16px] font-normal focus:border-[#636363] focus:outline-none focus:ring-1 focus:ring-[#636363] sm:text-sm"
          />
        </div>
      </nav>
    </section>
    <div class="flex w-full bg-white">
      <aside
        class="pointer-events-auto sticky hidden h-[750px] w-[260px] flex-col border-r-[1px] border-r-[#BBBBBB] bg-[#FAFAFA] pl-4 pt-4 lg:block"
      >
        <div>
          <ul>
            <span class="pl-5 text-base font-medium text-[#292d34]"
              >API Docs</span
            >

            <li class="">
              <div class="mt-[16px] flex pl-[6px]">
                <img
                  :src="$filters.media_path('/images/dropdown-dark-gray.svg')"
                  alt=""
                  class="mt-[5px] h-2 w-2"
                />
                <span class="ml-[5px] cursor-pointer text-[#5c6574]">
                  User Guides</span
                >
              </div>
            </li>

            <li class="">
              <div class="mt-[16px] flex pl-5">
                <img
                  :src="$filters.media_path('/images/dropdown-dark-gray.svg')"
                  alt=""
                  class="mt-[5px] h-2 w-2"
                />
                <span class="ml-[5px] cursor-pointer text-[#5c6574]"
                  >Getting Started</span
                >
              </div>
            </li>

            <p class="mt-5 pl-5 text-base font-medium text-[#292d34]">
              Reference
            </p>

            <li class="">
              <div class="mt-[16px] flex pl-[6px]">
                <img
                  :src="$filters.media_path('/images/dropdown-dark-gray.svg')"
                  alt=""
                  class="mt-[5px] h-2 w-2"
                />
                <span class="ml-[5px] cursor-pointer text-[#5c6574]">
                  User Guides</span
                >
              </div>
            </li>
          </ul>
        </div>
      </aside>

      <section class="mx-auto flex bg-white">
        <div class="h-[900px] flex-wrap px-[25px] md:w-[910px] lg:h-auto">
          <article class="">
            <h2 class="mt-12 mb-8 text-[36px] font-medium text-[#292d34]">
              Platforma API 1.0
            </h2>
            <p class="flex text-sm font-normal text-[#292d34]">
              Build your own custom integrations and Platforma apps with our
              public Application Programming Interface (API).
            </p>

            <h2
              class="mt-12 mb-8 text-[28px] font-medium text-[#292d34] md:text-[36px]"
            >
              Explore the Platforma API
            </h2>
            <p class="text-sm font-normal text-[#292d34]">
              Availability starting in Q3 2024
            </p>
          </article>
        </div>
      </section>
    </div>
    <footer
      class="flex flex-col border-t-[1px] border-[#E9EBF0] bg-[#f9fdff] align-bottom sm:justify-between xl:w-full"
    >
      <div class="mt-7 w-full md:ml-[25px] xl:ml-[60px] xl:w-full">
        <Link href="/">
          <img
            class="mx-auto flex h-[30px] md:ml-0"
            :src="$filters.media_path('/images/NEW_PLATFORMA_LOGO_1.svg')"
            alt="Platforma awesome logo"
          />
        </Link>
        <h4 class="mt-4 mb-5 text-center text-xs text-[#7c828d] md:text-left">
          ©
          {{ currentYear }}
          Platform Application, Inc. |
          <a href="/privacy"> Your Privacy</a> |
          <a href="/terms"> Terms</a>
        </h4>
      </div>
    </footer>
  </body>
</template>

<script>
const initApp = () => {
  const hamburgerBtn = document.getElementById('hamburger-button');
  const mobileMenu = document.getElementById('mobile-menu');

  const toggleMenu = () => {
    mobileMenu.classList.toggle('hidden');
    mobileMenu.classList.toggle('flex');
    hamburgerBtn.classList.toggle('toggle-btn');
  };

  hamburgerBtn.addEventListener('click', toggleMenu);
  mobileMenu.addEventListener('click', toggleMenu);
};

document.addEventListener('DOMContentLoaded', initApp);
</script>

<style scoped>
.api-header {
  background-image: url(../media/images/platforma-api-header-bg.svg);
  background-size: contain;
}

.range-slider .slider {
  -webkit-appearance: none;
}

.range-slider .slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  position: relative;
  width: 1.7em;
  height: 1.7em;
}
</style>
